export default {
  credentials: state => state.credentials,
  loading: state => state.loading
};
